import React from "react";
import { sliceString } from "../../theme/helpers";
import LocationIcon from "../Icons/LocationIcon";
import { Event, Content, OneDate, TwoDates, Title, Location } from "./CardEvent.styled";

var CardEventDate = function CardEventDate(props) {
  var from = new Date(props.dateFrom);
  var to = new Date(props.dateTo);

  if (props.dateFrom.substring(0, 10) === props.dateTo.substring(0, 10)) {
    return React.createElement(OneDate, null, React.createElement("div", null, from.getDate()), React.createElement("div", null, from.toLocaleString('default', {
      month: 'long'
    })), React.createElement("div", null, from.getFullYear()));
  }

  return React.createElement(TwoDates, null, React.createElement("span", null, from.getDate(), ".", from.getMonth() + 1, ".", from.getFullYear()), React.createElement("span", null, "-"), React.createElement("span", null, to.getDate(), ".", to.getMonth() + 1, ".", to.getFullYear()));
};

var CardEvent = function CardEvent(_a) {
  var url = _a.url,
      title = _a.title,
      location = _a.location,
      dateFrom = _a.dateFrom,
      dateTo = _a.dateTo;
  return React.createElement(Event, {
    to: url
  }, React.createElement(CardEventDate, {
    dateFrom: dateFrom,
    dateTo: dateTo
  }), React.createElement(Content, null, React.createElement(Title, null, sliceString(title, 52)), React.createElement(Location, null, React.createElement(LocationIcon, null), React.createElement("div", null, location))));
};

export default CardEvent;